export const environment = {
  production: true,
  frontUrl: 'https://webchat.culturametrodequito.com',
  apiUrl: 'https://apieneas.culturametrodequito.com/api/v1',
};
